import React, { useEffect, useState } from 'react';
import styles from './FreeVideos.module.css';
import VideoFormModal from './AddVideos/AddVideos';
import EditFreeVideo from './EditVideos/EditVideos';
import ArrangeSubjectsModal from './ArrangeSubjectsModal';
import axios from "../../constents/axios";
import { Modal, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  FaLaptopCode,
  FaAtom,
  FaLanguage,
  FaChalkboardTeacher,
  FaLandmark,
  FaBookOpen,
  FaBalanceScale,
  FaUsers,
  FaBroadcastTower,
  FaBook,
  FaGlobeAmericas,
  FaBriefcase,
  FaChartLine,
  FaCoins,
  FaBrain,
  FaGraduationCap,
  FaLayerGroup,
  FaArrowLeft,
  FaChevronRight,
  FaPlay,
  FaEdit,
  FaTrashAlt,
  FaExternalLinkAlt,
  FaVideo,
} from 'react-icons/fa';

// Clean, coordinated pastel palettes & icons for each subject card
const SUBJECT_CONFIG = {
  "All Subjects": {
    icon: FaLayerGroup,
    bg: '#f8fafc',
    border: '#cbd5e1',
    iconBg: '#e2e8f0',
    iconColor: '#334155',
    badgeBg: '#e2e8f0',
    badgeColor: '#1e293b',
  },
  "UGC NET Computer Science Courses": {
    icon: FaLaptopCode,
    bg: '#f0f9ff',
    border: '#bae6fd',
    iconBg: '#e0f2fe',
    iconColor: '#0284c7',
    badgeBg: '#e0f2fe',
    badgeColor: '#0369a1',
  },
  "CSIR NET": {
    icon: FaAtom,
    bg: '#faf5ff',
    border: '#e9d5ff',
    iconBg: '#f3e8ff',
    iconColor: '#9333ea',
    badgeBg: '#f3e8ff',
    badgeColor: '#7e22ce',
  },
  "UGC NET Malayalam Courses": {
    icon: FaLanguage,
    bg: '#ecfdf5',
    border: '#a7f3d0',
    iconBg: '#d1fae5',
    iconColor: '#059669',
    badgeBg: '#d1fae5',
    badgeColor: '#047857',
  },
  "AI for Teachers Courses": {
    icon: FaChalkboardTeacher,
    bg: '#fff7ed',
    border: '#fed7aa',
    iconBg: '#ffedd5',
    iconColor: '#ea580c',
    badgeBg: '#ffedd5',
    badgeColor: '#c2410c',
  },
  "UGC NET History Courses": {
    icon: FaLandmark,
    bg: '#fef2f2',
    border: '#fecaca',
    iconBg: '#fee2e2',
    iconColor: '#dc2626',
    badgeBg: '#fee2e2',
    badgeColor: '#b91c1c',
  },
  "UGC NET Paper 1 Courses": {
    icon: FaBookOpen,
    bg: '#eef2ff',
    border: '#c7d2fe',
    iconBg: '#e0e7ff',
    iconColor: '#4f46e5',
    badgeBg: '#e0e7ff',
    badgeColor: '#4338ca',
  },
  "UGC NET Political Science Courses": {
    icon: FaBalanceScale,
    bg: '#fdf4ff',
    border: '#f5d0fe',
    iconBg: '#fae8ff',
    iconColor: '#c026d3',
    badgeBg: '#fae8ff',
    badgeColor: '#a21caf',
  },
  "UGC NET Sociology Courses": {
    icon: FaUsers,
    bg: '#f0fdf4',
    border: '#bbf7d0',
    iconBg: '#dcfce7',
    iconColor: '#16a34a',
    badgeBg: '#dcfce7',
    badgeColor: '#15803d',
  },
  "UGC NET Mass Communication and Journalism Courses": {
    icon: FaBroadcastTower,
    bg: '#fff1f2',
    border: '#fecdd3',
    iconBg: '#ffe4e6',
    iconColor: '#e11d48',
    badgeBg: '#ffe4e6',
    badgeColor: '#be123c',
  },
  "UGC NET English Courses": {
    icon: FaBook,
    bg: '#f5f3ff',
    border: '#ddd6fe',
    iconBg: '#ede9fe',
    iconColor: '#7c3aed',
    badgeBg: '#ede9fe',
    badgeColor: '#6d28d9',
  },
  "UGC NET Arabic Courses": {
    icon: FaGlobeAmericas,
    bg: '#f0fdfa',
    border: '#99f6e4',
    iconBg: '#ccfbf1',
    iconColor: '#0d9488',
    badgeBg: '#ccfbf1',
    badgeColor: '#0f766e',
  },
  "UGC NET Management Courses": {
    icon: FaBriefcase,
    bg: '#eff6ff',
    border: '#bfdbfe',
    iconBg: '#dbeafe',
    iconColor: '#2563eb',
    badgeBg: '#dbeafe',
    badgeColor: '#1d4ed8',
  },
  "UGC NET Commerce Courses": {
    icon: FaChartLine,
    bg: '#fefce8',
    border: '#fef08a',
    iconBg: '#fef9c3',
    iconColor: '#ca8a04',
    badgeBg: '#fef9c3',
    badgeColor: '#a16207',
  },
  "UGC NET Economics Courses": {
    icon: FaCoins,
    bg: '#f8fafc',
    border: '#cbd5e1',
    iconBg: '#e2e8f0',
    iconColor: '#475569',
    badgeBg: '#e2e8f0',
    badgeColor: '#334155',
  },
  "UGC NET Psychology Courses": {
    icon: FaBrain,
    bg: '#fffbeb',
    border: '#fde68a',
    iconBg: '#fef3c7',
    iconColor: '#d97706',
    badgeBg: '#fef3c7',
    badgeColor: '#b45309',
  },
  "Paper 1 Courses": {
    icon: FaGraduationCap,
    bg: '#eef2ff',
    border: '#c7d2fe',
    iconBg: '#e0e7ff',
    iconColor: '#6366f1',
    badgeBg: '#e0e7ff',
    badgeColor: '#4f46e5',
  },
};

// Fixed coordinated pastel palettes & icons for dynamic fallback subjects (exactly 9 curated schemes)
const FALLBACK_PALETTES = [
  {
    icon: FaBriefcase,
    bg: '#eff6ff',
    border: '#bfdbfe',
    iconBg: '#DBEAFE',
    iconColor: '#1D4ED8',
    badgeBg: '#DBEAFE',
    badgeColor: '#1D4ED8',
  }, // 1. Blue
  {
    icon: FaLanguage,
    bg: '#ecfdf5',
    border: '#a7f3d0',
    iconBg: '#D1FAE5',
    iconColor: '#047857',
    badgeBg: '#D1FAE5',
    badgeColor: '#047857',
  }, // 2. Green
  {
    icon: FaBook,
    bg: '#f5f3ff',
    border: '#ddd6fe',
    iconBg: '#EDE9FE',
    iconColor: '#6D28D9',
    badgeBg: '#EDE9FE',
    badgeColor: '#6D28D9',
  }, // 3. Purple
  {
    icon: FaChalkboardTeacher,
    bg: '#fff7ed',
    border: '#fed7aa',
    iconBg: '#FFEDD5',
    iconColor: '#C2410C',
    badgeBg: '#FFEDD5',
    badgeColor: '#C2410C',
  }, // 4. Orange
  {
    icon: FaLandmark,
    bg: '#fdf2f8',
    border: '#fbcfe8',
    iconBg: '#FCE7F3',
    iconColor: '#BE185D',
    badgeBg: '#FCE7F3',
    badgeColor: '#BE185D',
  }, // 5. Pink
  {
    icon: FaGlobeAmericas,
    bg: '#f0fdfa',
    border: '#99f6e4',
    iconBg: '#CCFBF1',
    iconColor: '#0F766E',
    badgeBg: '#CCFBF1',
    badgeColor: '#0F766E',
  }, // 6. Teal
  {
    icon: FaBrain,
    bg: '#fffbeb',
    border: '#fde68a',
    iconBg: '#FEF3C7',
    iconColor: '#92400E',
    badgeBg: '#FEF3C7',
    badgeColor: '#92400E',
  }, // 7. Amber
  {
    icon: FaBookOpen,
    bg: '#eef2ff',
    border: '#c7d2fe',
    iconBg: '#E0E7FF',
    iconColor: '#4338CA',
    badgeBg: '#E0E7FF',
    badgeColor: '#4338CA',
  }, // 8. Indigo
  {
    icon: FaBroadcastTower,
    bg: '#fff1f2',
    border: '#fecdd3',
    iconBg: '#FFE4E6',
    iconColor: '#BE123C',
    badgeBg: '#FFE4E6',
    badgeColor: '#BE123C',
  }, // 9. Rose
];

// Returns either dedicated SUBJECT_CONFIG or deterministic fallback based on subject name
const getSubjectCardConfig = (subjectName) => {
  if (SUBJECT_CONFIG[subjectName]) {
    return SUBJECT_CONFIG[subjectName];
  }
  // Deterministic string hash for consistent fallback assignment
  const str = subjectName || '';
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }
  const index = Math.abs(hash) % FALLBACK_PALETTES.length;
  return FALLBACK_PALETTES[index];
};

// Extract YouTube Video ID from yt_id or valid YouTube URLs
const getYouTubeVideoId = (ytId, url) => {
  if (ytId && typeof ytId === 'string' && ytId.trim().length >= 6) {
    return ytId.trim();
  }
  if (!url || typeof url !== 'string') return '';
  try {
    const ytURL = new URL(url);
    const host = ytURL.hostname.toLowerCase();
    const isYouTube =
      host.includes('youtube.com') ||
      host.includes('youtu.be') ||
      host.includes('youtube-nocookie.com');
    if (!isYouTube) return '';

    if (ytURL.searchParams.has('v')) {
      const v = ytURL.searchParams.get('v');
      if (v && v.length >= 6) return v;
    }

    const pathSegments = ytURL.pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1];
    if (lastSegment && lastSegment.length >= 6) {
      return lastSegment;
    }
    return '';
  } catch {
    return '';
  }
};

const FreeVideos = () => {
  const [modalShow, setModalShow] = useState(false);
  const [editModalShow, setEditModalShow] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videos, setVideos] = useState([]);
  const [filterSubject, setFilterSubject] = useState("All");
  const [sortOrder, setSortOrder] = useState("priority"); // 'priority' (saved order), 'asc' (A-Z), 'desc' (Z-A)
  const [selectedSubjectView, setSelectedSubjectView] = useState(null); // null = card grid, 'All' or subjectName = video list
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 780);

  // Subject ordering state
  const [showArrangeModal, setShowArrangeModal] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);

  // Video ordering state
  const [isEditingVideoOrder, setIsEditingVideoOrder] = useState(false);
  const [videoOrderInputs, setVideoOrderInputs] = useState({});
  const [savingVideoOrder, setSavingVideoOrder] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 780);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openAddModal = () => {
    if (selectedSubjectView && selectedSubjectView !== 'All') {
      setSelectedVideo({ subject: selectedSubjectView });
    } else {
      setSelectedVideo(null);
    }
    setModalShow(true);
  };

  const openEditModal = (video) => {
    setSelectedVideo(video);
    setEditModalShow(true);
  };

  const openArrangeModal = () => {
    setShowArrangeModal(true);
  };

  const closeArrangeModal = () => {
    if (savingOrder) return;
    setShowArrangeModal(false);
  };

  const handleSaveSubjectOrder = async (orderedSubjects) => {
    if (savingOrder) return;
    setSavingOrder(true);
    try {
      const response = await axios.put('/api/reorder-subjects', {
        orderedSubjects,
      });

      if (response.status === 200 || response.status === 204 || response.data?.success) {
        toast.success('Subject order saved successfully!', {
          position: 'top-right',
          autoClose: 1500,
        });
        setSortOrder('priority');
        setShowArrangeModal(false);
        await fetchVideos();
      } else {
        toast.error('Failed to save subject order. Please try again.');
      }
    } catch (error) {
      console.error('Error saving subject order:', error);
      const errMsg = error.response?.data?.message || 'Something went wrong while saving subject order.';
      toast.error(errMsg);
    } finally {
      setSavingOrder(false);
    }
  };

  const fetchVideos = async () => {
    try {
      const response = await axios.get("/api/get-Freevideos");
      const result = response.data;
      setVideos(result.data || []);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleAddSubmit = (videoData) => {
    setVideos(prev => [videoData, ...prev]);
  };

  const handleEditSubmit = (updatedVideo) => {
    setVideos(prev => prev.map(v => (v.id === updatedVideo.id ? updatedVideo : v)));
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      const response = await axios.delete(`/api/delete-FreeVideo/${deleteId}`);
      if (response.status === 200) {
        setVideos(prev => prev.filter(video => video.id !== deleteId));
        setShowDeleteModal(false);
        setDeleteId(null);
        toast.success('Video deleted successfully!', {
          position: 'top-right',
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        alert('Failed to delete video.');
      }
    } catch (error) {
      console.error('Error deleting FreeVideo:', error);
      alert('Something went wrong while deleting the video.');
    }
  };

  // Video ordering handlers
  const handleStartEditOrder = () => {
    const initialInputs = {};
    displayedVideos.forEach((v, index) => {
      initialInputs[v.id] = index + 1;
    });
    setVideoOrderInputs(initialInputs);
    setIsEditingVideoOrder(true);
  };

  const handleCancelEditOrder = () => {
    if (savingVideoOrder) return;
    setIsEditingVideoOrder(false);
    setVideoOrderInputs({});
  };

  const handleVideoOrderInputChange = (videoId, value) => {
    // If the input is empty or invalid, allow the user to type freely
    if (value === '' || value === null || value === undefined) {
      setVideoOrderInputs(prev => ({
        ...prev,
        [videoId]: value,
      }));
      return;
    }

    const num = Number(value);
    if (!Number.isInteger(num) || num <= 0) {
      setVideoOrderInputs(prev => ({
        ...prev,
        [videoId]: value,
      }));
      return;
    }

    // Auto-shift other videos to maintain unique sequential positions starting at 1
    const totalVideos = displayedVideos.length;
    const targetPos = Math.min(Math.max(num, 1), totalVideos);

    // Current ordered list based on existing inputs or display sequence
    const currentOrder = [...displayedVideos].sort((a, b) => {
      const posA = Number(videoOrderInputs[a.id]) || 0;
      const posB = Number(videoOrderInputs[b.id]) || 0;
      return posA - posB;
    });

    const withoutCurrent = currentOrder.filter(v => v.id !== videoId);
    const targetIndex = targetPos - 1;
    const movedItem = displayedVideos.find(v => v.id === videoId);

    const reorderedList = [
      ...withoutCurrent.slice(0, targetIndex),
      movedItem,
      ...withoutCurrent.slice(targetIndex),
    ];

    const nextInputs = {};
    reorderedList.forEach((v, idx) => {
      if (v) {
        nextInputs[v.id] = idx + 1;
      }
    });

    setVideoOrderInputs(nextInputs);
  };

  const handleSaveVideoOrder = async () => {
    if (savingVideoOrder) return;

    if (!selectedSubjectView || selectedSubjectView === 'All') {
      toast.error('Please select a specific subject to reorder its videos.');
      return;
    }

    // Get all videos belonging to the selected subject
    const subjectVideos = videos.filter(v => v.subject === selectedSubjectView);
    if (subjectVideos.length === 0) {
      toast.error('No videos found for this subject.');
      return;
    }

    // Validate that order values are positive integers
    for (const v of subjectVideos) {
      const rawVal = videoOrderInputs[v.id];
      if (rawVal === undefined || rawVal === null || String(rawVal).trim() === '') {
        toast.error(`Please enter a valid numeric order for "${v.title || `Video #${v.id}`}".`);
        return;
      }

      const num = Number(rawVal);
      if (!Number.isInteger(num) || num <= 0) {
        toast.error(`Order values must be positive integers (1, 2, 3...). Invalid value for "${v.title || `Video #${v.id}`}".`);
        return;
      }
    }

    // Sort complete video ID list ascending by the order values
    const sortedSubjectVideos = [...subjectVideos].sort((a, b) => {
      const orderA = Number(videoOrderInputs[a.id]);
      const orderB = Number(videoOrderInputs[b.id]);
      return orderA - orderB;
    });

    const orderedVideoIds = sortedSubjectVideos.map(v => Number(v.id));

    setSavingVideoOrder(true);
    try {
      const response = await axios.put('/api/reorder-videos', {
        subject: selectedSubjectView,
        orderedVideoIds,
      });

      if (response.status === 200 || response.status === 204 || response.data?.success) {
        toast.success('Video order saved successfully!', {
          position: 'top-right',
          autoClose: 1500,
        });
        setIsEditingVideoOrder(false);
        setVideoOrderInputs({});
        await fetchVideos();
      } else {
        toast.error('Failed to save video order. Please check inputs and try again.');
      }
    } catch (error) {
      console.error('Error saving video order:', error);
      const errMsg = error.response?.data?.message || 'Something went wrong while saving video order.';
      toast.error(errMsg);
      // On failure, preserve entered values so admin can retry
    } finally {
      setSavingVideoOrder(false);
    }
  };

  // Unique subjects derived with subject_order preservation
  const prioritySubjects = (() => {
    // Collect unique subjects and their lowest recorded subject_order
    const subjectOrderMap = new Map();
    const orderedUniqueList = [];

    videos.forEach((v) => {
      const subj = v.subject?.trim();
      if (!subj) return;

      const orderVal = typeof v.subject_order === 'number'
        ? v.subject_order
        : v.subject_order != null && !isNaN(Number(v.subject_order))
          ? Number(v.subject_order)
          : null;

      if (!subjectOrderMap.has(subj)) {
        subjectOrderMap.set(subj, orderVal);
        orderedUniqueList.push(subj);
      } else {
        const existingOrder = subjectOrderMap.get(subj);
        if (existingOrder === null && orderVal !== null) {
          subjectOrderMap.set(subj, orderVal);
        } else if (existingOrder !== null && orderVal !== null && orderVal < existingOrder) {
          subjectOrderMap.set(subj, orderVal);
        }
      }
    });

    const hasExplicitOrdering = Array.from(subjectOrderMap.values()).some((val) => val !== null);

    if (hasExplicitOrdering) {
      return [...orderedUniqueList].sort((a, b) => {
        const orderA = subjectOrderMap.get(a);
        const orderB = subjectOrderMap.get(b);
        if (orderA !== null && orderB !== null) return orderA - orderB;
        if (orderA !== null) return -1;
        if (orderB !== null) return 1;
        return a.localeCompare(b);
      });
    }

    return orderedUniqueList;
  })();

  // Fallback subjects reference
  const subjects = prioritySubjects;

  // Video counts by subject
  const videoCountsBySubject = videos.reduce((acc, video) => {
    const subj = video.subject?.trim();
    if (subj) {
      acc[subj] = (acc[subj] || 0) + 1;
    }
    return acc;
  }, {});

  // Dynamically sorted subject cards based on active dropdown selection
  const sortedSubjects = (() => {
    if (sortOrder === 'asc') {
      return [...prioritySubjects].sort((a, b) => a.localeCompare(b));
    }
    if (sortOrder === 'desc') {
      return [...prioritySubjects].sort((a, b) => b.localeCompare(a));
    }
    // 'priority' or 'custom' default
    return prioritySubjects;
  })();

  // Handler when clicking a card on landing page
  const handleSelectSubjectCard = (subjectName) => {
    setIsEditingVideoOrder(false);
    setVideoOrderInputs({});
    setSelectedSubjectView(subjectName);
    setFilterSubject(subjectName);
  };

  // Handler when user changes the existing filter dropdown
  const handleDropdownChange = (value) => {
    setIsEditingVideoOrder(false);
    setVideoOrderInputs({});
    setFilterSubject(value);
    if (!selectedSubjectView) {
      // If currently on cards view and user selects a specific subject or All, switch to video list
      setSelectedSubjectView(value);
    } else {
      setSelectedSubjectView(value);
    }
  };

  // Filtered and sorted videos according to active view and existing dropdown
  const displayedVideos = (() => {
    const activeSubject = selectedSubjectView || filterSubject;
    const filtered = videos.filter((v) => {
      if (!activeSubject || activeSubject === "All") return true;
      return v.subject === activeSubject;
    });

    // When viewing a specific subject, sort by saved video_order ascending
    if (activeSubject && activeSubject !== 'All') {
      return [...filtered].sort((a, b) => {
        const orderA = typeof a.video_order === 'number'
          ? a.video_order
          : a.video_order != null && !isNaN(Number(a.video_order))
            ? Number(a.video_order)
            : null;
        const orderB = typeof b.video_order === 'number'
          ? b.video_order
          : b.video_order != null && !isNaN(Number(b.video_order))
            ? Number(b.video_order)
            : null;

        if (orderA !== null && orderB !== null) return orderA - orderB;
        if (orderA !== null) return -1;
        if (orderB !== null) return 1;
        return (Number(a.id) || 0) - (Number(b.id) || 0);
      });
    }

    return filtered;
  })();

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <div className={styles.headerLeft}>
          {selectedSubjectView && (
            <button
              className={styles.backButton}
              onClick={() => {
                setIsEditingVideoOrder(false);
                setVideoOrderInputs({});
                setSelectedSubjectView(null);
                setFilterSubject("All");
              }}
              title="Back to Subject Cards"
            >
              <FaArrowLeft />
              <span>Back</span>
            </button>
          )}
          <div className={styles.headingGroup}>
            <h2 className={styles.heading}>
              {selectedSubjectView && selectedSubjectView !== 'All'
                ? selectedSubjectView
                : selectedSubjectView === 'All'
                  ? 'All Free Videos'
                  : 'Free Videos'}
            </h2>
            {selectedSubjectView && (
              <span className={styles.headerCountBadge}>
                {displayedVideos.length} {displayedVideos.length === 1 ? 'Video' : 'Videos'}
              </span>
            )}
          </div>
        </div>

        <div className={styles.actions}>
          {/* Sort Control for Subject Cards (Visible on Landing Page) */}
          {!selectedSubjectView && (
            <div className={styles.sortControl}>
              <label htmlFor="sortOrderSelect" className={styles.sortLabel}>
                Sort Subjects:
              </label>
              <select
                id="sortOrderSelect"
                className={styles.sortDropdown}
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
              >
                <option value="priority">Priority</option>
                <option value="asc">Ascending (A–Z)</option>
                <option value="desc">Descending (Z–A)</option>
              </select>
              <button
                type="button"
                className={styles.arrangeButton}
                onClick={openArrangeModal}
                title="Arrange subject order via drag and drop"
              >
                Arrange Order
              </button>
            </div>
          )}

          {/* Video Ordering Controls (Visible when viewing a specific subject's videos) */}
          {selectedSubjectView && selectedSubjectView !== 'All' && displayedVideos.length > 0 && (
            !isEditingVideoOrder ? (
              <button
                type="button"
                className={styles.editOrderButton}
                onClick={handleStartEditOrder}
                title="Edit video order for this subject"
              >
                Edit Order
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className={styles.saveVideoOrderBtn}
                  onClick={handleSaveVideoOrder}
                  disabled={savingVideoOrder}
                  title="Save new video order"
                >
                  {savingVideoOrder ? 'Saving...' : 'Save Order'}
                </button>
                <button
                  type="button"
                  className={styles.cancelVideoOrderBtn}
                  onClick={handleCancelEditOrder}
                  disabled={savingVideoOrder}
                  title="Cancel reordering"
                >
                  Cancel
                </button>
              </>
            )
          )}

          <button className={styles.addButton} onClick={openAddModal}>+ Add Video</button>
        </div>
      </div>

      {/* VIEW 1: SUBJECT CARDS GRID (Landing Page) */}
      {!selectedSubjectView && (
        <div className={styles.subjectGrid}>
          {/* CARD 1: All Subjects (Always pinned first) */}
          {(() => {
            const config = SUBJECT_CONFIG["All Subjects"];
            const Icon = config.icon;
            return (
              <div
                key="All"
                className={styles.subjectCard}
                style={{
                  backgroundColor: config.bg,
                  borderColor: config.border,
                }}
                onClick={() => handleSelectSubjectCard('All')}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleSelectSubjectCard('All');
                  }
                }}
              >
                <div className={styles.cardTopRow}>
                  <div
                    className={styles.iconWrapper}
                    style={{
                      backgroundColor: config.iconBg,
                      color: config.iconColor,
                    }}
                  >
                    <Icon />
                  </div>
                  <span
                    className={styles.badge}
                    style={{
                      backgroundColor: config.badgeBg,
                      color: config.badgeColor,
                    }}
                  >
                    {videos.length} {videos.length === 1 ? 'Video' : 'Videos'}
                  </span>
                </div>
                <h4 className={styles.subjectName}>All Subjects</h4>
                <div className={styles.cardFooter} style={{ color: config.iconColor }}>
                  <span>View all free videos</span>
                  <FaChevronRight />
                </div>
              </div>
            );
          })()}

          {/* DYNAMIC SUBJECT CARDS (Sorted A-Z or Z-A) */}
          {sortedSubjects.map((subjectName) => {
            const count = videoCountsBySubject[subjectName] || 0;
            const config = getSubjectCardConfig(subjectName);
            const Icon = config.icon;

            return (
              <div
                key={subjectName}
                className={styles.subjectCard}
                style={{
                  backgroundColor: config.bg,
                  borderColor: config.border,
                }}
                onClick={() => handleSelectSubjectCard(subjectName)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleSelectSubjectCard(subjectName);
                  }
                }}
              >
                <div className={styles.cardTopRow}>
                  <div
                    className={styles.iconWrapper}
                    style={{
                      backgroundColor: config.iconBg,
                      color: config.iconColor,
                    }}
                  >
                    <Icon />
                  </div>
                  <span
                    className={styles.badge}
                    style={{
                      backgroundColor: config.badgeBg,
                      color: config.badgeColor,
                    }}
                  >
                    {count} {count === 1 ? 'Video' : 'Videos'}
                  </span>
                </div>
                <h4 className={styles.subjectName}>{subjectName}</h4>
                <div className={styles.cardFooter} style={{ color: config.iconColor }}>
                  <span>Explore subject</span>
                  <FaChevronRight />
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* VIEW 2: VIDEO LIST (When a subject card or dropdown selection is active) */}
      {selectedSubjectView && (
        <div className={styles.videoListWrapper}>
          {displayedVideos.length === 0 ? (
            <div className={styles.emptyState}>
              <div className={styles.emptyIconWrapper}>
                <FaVideo />
              </div>
              <h4 className={styles.emptyTitle}>No videos available</h4>
              <p className={styles.emptySubtitle}>
                No free videos found for <strong>{selectedSubjectView}</strong>. Add your first video to get started.
              </p>
              <button className={styles.addButton} onClick={openAddModal} style={{ marginTop: '0.5rem' }}>
                + Add Video
              </button>
            </div>
          ) : (
            <div className={styles.videoGrid}>
              {displayedVideos.map((video, index) => {
                const ytId = getYouTubeVideoId(video.yt_id, video.url);
                const hasPlaylist = video.playlist && video.playlist.trim() !== '';

                return (
                  <div key={video.id || index} className={styles.videoCard}>
                    {/* Numeric Order Input (Visible only in Edit Order mode) */}
                    {isEditingVideoOrder && (
                      <div className={styles.videoOrderEditBar}>
                        <span className={styles.videoOrderLabel}>Order #</span>
                        <input
                          type="number"
                          min="1"
                          step="1"
                          className={styles.videoOrderInput}
                          value={videoOrderInputs[video.id] ?? ''}
                          onChange={(e) => handleVideoOrderInputChange(video.id, e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                          title="Enter video position order"
                        />
                      </div>
                    )}

                    {/* Thumbnail / Media Container */}
                    <div className={styles.thumbnailContainer}>
                      {ytId ? (
                        <a
                          href={video.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.thumbnailLink}
                          title={`Watch "${video.title}" on YouTube`}
                        >
                          <img
                            src={`https://img.youtube.com/vi/${ytId}/mqdefault.jpg`}
                            alt={video.title || 'Video Thumbnail'}
                            className={styles.thumbnailImage}
                            loading="lazy"
                            onError={(e) => {
                              // If YouTube thumbnail fails to load, switch to fallback
                              e.currentTarget.style.display = 'none';
                              const fallback = e.currentTarget.nextElementSibling;
                              if (fallback) fallback.style.display = 'flex';
                            }}
                          />
                          <div className={styles.thumbnailFallback} style={{ display: 'none' }}>
                            <FaVideo className={styles.fallbackIcon} />
                            <span>Video</span>
                          </div>
                          <div className={styles.playOverlay}>
                            <div className={styles.playButtonCircle}>
                              <FaPlay className={styles.playIcon} />
                            </div>
                          </div>
                        </a>
                      ) : (
                        <a
                          href={video.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.thumbnailLink}
                          title={video.url ? `Open "${video.title}"` : video.title}
                        >
                          <div className={styles.thumbnailFallback}>
                            <FaVideo className={styles.fallbackIcon} />
                            <span>Web Video</span>
                          </div>
                          {video.url && (
                            <div className={styles.playOverlay}>
                              <div className={styles.playButtonCircle}>
                                <FaPlay className={styles.playIcon} />
                              </div>
                            </div>
                          )}
                        </a>
                      )}

                      {/* Index badge overlaid on top-left of thumbnail */}
                      <span className={styles.indexBadge}>#{index + 1}</span>
                    </div>

                    {/* Card Content */}
                    <div className={styles.videoCardBody}>
                      <div className={styles.videoTagsRow}>
                        <span className={styles.subjectTag} title={`Subject: ${video.subject}`}>
                          {video.subject}
                        </span>
                        {hasPlaylist && (
                          <span className={styles.playlistTag} title={`Playlist: ${video.playlist}`}>
                            {video.playlist}
                          </span>
                        )}
                      </div>

                      <h4 className={styles.videoTitle} title={video.title}>
                        {video.title}
                      </h4>

                      {/* Video Link */}
                      {video.url && (
                        <div className={styles.videoLinkRow}>
                          <a
                            href={video.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.videoUrlLink}
                            title={video.url}
                          >
                            <FaExternalLinkAlt className={styles.externalIcon} />
                            <span className={styles.videoUrlText}>{video.url}</span>
                          </a>
                        </div>
                      )}

                      {/* Card Actions */}
                      <div className={styles.videoActionsRow}>
                        <button
                          type="button"
                          className={styles.editActionBtn}
                          onClick={() => openEditModal(video)}
                          title="Edit Video"
                        >
                          <FaEdit />
                          <span>Edit</span>
                        </button>
                        <button
                          type="button"
                          className={styles.deleteActionBtn}
                          onClick={() => confirmDelete(video.id)}
                          title="Delete Video"
                        >
                          <FaTrashAlt />
                          <span>Delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      <VideoFormModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        initialData={selectedVideo}
        onSubmit={handleAddSubmit}
      />

      <EditFreeVideo
        show={editModalShow}
        handleClose={() => setEditModalShow(false)}
        videoData={selectedVideo}
        onSuccess={handleEditSubmit}
      />

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this video?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
          <Button variant="danger" onClick={handleDelete}>Delete</Button>
        </Modal.Footer>
      </Modal>

      {/* Arrange Subject Order Modal */}
      <ArrangeSubjectsModal
        show={showArrangeModal}
        onHide={closeArrangeModal}
        subjects={prioritySubjects}
        videoCountsBySubject={videoCountsBySubject}
        getSubjectConfig={getSubjectCardConfig}
        onSave={handleSaveSubjectOrder}
        isSaving={savingOrder}
      />

      <ToastContainer />
    </div>
  );
};

export default FreeVideos;

